export default "__VITE_ASSET__DKZtoFoy__"